<template>
    <CollapsibleCard :title="title" :actions="actions">
        <template v-slot:content>
            <div class="mb-4">{{ application.comment }}</div>

            <div v-if="application.posts.length == 0" class="text--disabled">
                {{ $translate('No applications yet') }}
            </div>

            <TeamsportPlayerPoolPost
                v-for="post in application.posts" :key="post.id"
                :post="post"
                :showReplyButton="true"
                type="usergrouprequest"
                class="mb-4"
            >
                <template #title>
                    <div class="font-weight-bold">{{ post.user.name }}</div>
                </template>
            </TeamsportPlayerPoolPost>

            <TeamsportPlayerPoolTeamPostDialog
                v-model="showEditDialog"
                :groups="groups"
                :add="false"
                :post="application"
                v-if="showEditDialog"
            />
        </template>
    </CollapsibleCard>
</template>

<script>
import CollapsibleCard from '../components/CollapsibleCard.vue'
import TeamsportPlayerPoolPost from './TeamsportPlayerPoolPost.vue'
import TeamsportPlayerPoolTeamPostDialog from './TeamsportPlayerPoolTeamPostDialog.vue'
export default {
    name: 'zoezi-teamsport-player-pool-recruitment-card',
    props: {
        application: {
            type: Object
        },
        groups: {
            type: Array
        }
    },

    components: {
        CollapsibleCard,
        TeamsportPlayerPoolPost,
        TeamsportPlayerPoolTeamPostDialog
    },

    data: () => ({
        showEditDialog: false
    }),

    computed: {
        title() {
            return this.$translate('Applications for {0}').format(this.application.group.name)
        },
        actions() {
            return [
                {
                    title: this.$translate('Edit'),
                    action: () => {
                        this.showEditDialog = true;
                    }
                },
                {
                    title: this.$translate('Remove'),
                    action: () => {
                        this.$store.commit('showConfirmDialog', {
                            title: this.$translate('Remove post'),
                            text: this.$translate('Are you sure you want to remove the post?'),
                            actionText: this.$translate('Remove'),
                            action: () => {
                                this.$api.post('/api/playerpoolteam/remove', null, {id: this.application.id}).then(response => {
                                    if (response.ok) {
                                        this.showDialog = false
                                    }
                                    this.possiblyShowError(response)
                                });
                            }
                        });
                    }
                }
            ]
        }
    },

    methods: {
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        }
    }
}
</script>
